/**
 * SubscriptionUsageResponse (stored at subscription.subscription.usage):
 * - stripe_subscription_id: string
 * - stripe_invoice_id?: string
 * - period_start: number
 * - period_end: number
 * - items: SubscriptionUsageItem[]
 *
 * SubscriptionUsageItem:
 * - meter_id: string
 * - meter_name: string
 * - event_name: string
 * - limit: number
 * - usage: number
 */

export const getUsageItems = (usage) => {
  if (!usage) {
    return [];
  }
  return Array.isArray(usage.items) ? usage.items : [];
};

export const getUsageItemMeterName = (item) => item?.meter_name || item?.meter_id || 'Unknown meter';

export const getUsageItemsAtThreshold = (usage, thresholdRatio = 1) => {
  return getUsageItems(usage).filter((item) => {
    const limit = Number(item.limit ?? 0);
    const used = Number(item.usage ?? 0);
    return limit > 0 && used >= thresholdRatio * limit;
  });
};

export const buildSubscriptionUsageDisplayItems = (subscription) => {
  return getUsageItems(subscription?.usage).map((item) => {
    const limit = Number(item.limit ?? 0);
    const used = Number(item.usage ?? 0);

    return {
      meterName: item.meter_name || 'Usage',
      meterCode: item.meter_id || '-',
      eventName: item.event_name || '',
      used,
      limit,
      progress: limit > 0 ? Math.min((used / limit) * 100, 100) : 0,
      isUnlimited: limit === 0,
    };
  });
};

export const isSubscriptionUsageLimitReached = (subscription) =>
  getUsageItemsAtThreshold(subscription?.usage, 1).length > 0;
